// /src/components/calendar/EventSidebar.js
import { Pencil, Trash2 } from "lucide-react";

const MONTHS = ["January","February","March","April","May","June","July","August","September","October","November","December"];

export default function EventSidebar({ token, current, selected, events, setEvents, onAddEvent, onEditEvent }) {
  const selectedEvents = selected
    ? events.filter(e => {
        const d = new Date(e.start?.dateTime || e.start?.date);
        return d.getFullYear() === current.year && d.getMonth() === current.month && d.getDate() === selected;
      })
    : [];

  const handleDelete = async (eventId) => {
    if (!window.confirm("Cancel this event? This will delete it from Google Calendar.")) return;
    try {
      const res = await fetch(`/api/gcalendarevents?eventId=${eventId}`, {
        method: "DELETE",
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await res.json();
      if (data.success) {
        setEvents(prev => prev.filter(e => e.id !== eventId));
      } else {
        alert("Failed to delete event: " + (data.error || "unknown error"));
      }
    } catch (err) {
      console.error(err);
      alert("Network error. Please try again.");
    }
  };

  return (
    <div className="card" style={{ padding: 20 }}>
      <div style={{ fontWeight: 700, fontSize: 14, color: "#0f172a", marginBottom: 16 }}>
        {selected ? `${MONTHS[current.month]} ${selected}, ${current.year}` : "Select a day"}
      </div>

      {!selected && <p style={{ color: "#94a3b8", fontSize: 13 }}>Click a day to see events.</p>}

      {selected && selectedEvents.length === 0 && (
        <div style={{ color: "#94a3b8", fontSize: 13 }}>
          No events.<br />
          <button className="btn btn-secondary" style={{ marginTop: 10, fontSize: 12 }} onClick={onAddEvent}>
            + Add event
          </button>
        </div>
      )}

      {selectedEvents.map(e => {
        const start = e.start?.dateTime ? new Date(e.start.dateTime) : null;
        const end = e.end?.dateTime ? new Date(e.end.dateTime) : null;
        return (
          <div key={e.id} style={{ marginBottom: 12, padding: 12, background: "#f8fafc", borderRadius: 8, borderLeft: "3px solid #2563eb" }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 4 }}>
              <div style={{ fontWeight: 600, fontSize: 13, color: "#0f172a" }}>{e.summary}</div>
              <div style={{ display: "flex", gap: 4, flexShrink: 0, marginLeft: 8 }}>
                <button onClick={() => onEditEvent(e)} title="Edit"
                  style={{ background: "none", border: "none", cursor: "pointer", color: "#64748b", padding: 2, borderRadius: 4, display: "flex" }}>
                  <Pencil size={13} />
                </button>
                <button onClick={() => handleDelete(e.id)} title="Delete"
                  style={{ background: "none", border: "none", cursor: "pointer", color: "#ef4444", padding: 2, borderRadius: 4, display: "flex" }}>
                  <Trash2 size={13} />
                </button>
              </div>
            </div>
            {start && (
              <div style={{ fontSize: 12, color: "#64748b" }}>
                {start.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}
                {end && ` – ${end.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}`}
              </div>
            )}
            {e.location && <div style={{ fontSize: 12, color: "#64748b", marginTop: 2 }}>{e.location}</div>}
            {e.description && <div style={{ fontSize: 11, color: "#94a3b8", marginTop: 4 }}>{e.description}</div>}
          </div>
        );
      })}
    </div>
  );
}